import React from "react";
import EditOldPurchase from "./EditOldPurchase";

/** View-only URD / old metal purchase — same UI as edit, loads show API only. */
export default function ViewOldPurchase({
  purchaseId,
  purchaseNo,
  onClose,
  masterGoldRate,
  masterSilverRate,
  showLiveRate = false,
}) {
  return (
    <EditOldPurchase
      purchaseId={purchaseId}
      purchaseNo={purchaseNo}
      onClose={onClose}
      masterGoldRate={masterGoldRate}
      masterSilverRate={masterSilverRate}
      showLiveRate={showLiveRate}
      viewOnly
    />
  );
}
